<!--suppress JSUnresolvedVariable -->
<template>
  <div class="company-info">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-primary">
        <h1 class="animated fadeInDown">公司简介</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container content my-5">
      <!-- 面包屑导航 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">公司简介</a>
      </div>
      <h3 class="text-center text-primary font-weight-bold animated fadeInDown">
        公司
        <img :src="titleImgUrl" alt="logo" class="mx-2" width="50" />
        简介
      </h3>
      <div class="text-center  mb-4 text-secondary animated fadeInUp">
        —— {{ sectionSubTitle }} ——
      </div>
      <div class="lead" v-html="companyIntroduction"></div>
    </div>
  </div>
</template>

<!--suppress ES6CheckImport -->
<script>
import { WOW } from "wowjs";

export default {
  name: "CompanyInfo",
  data() {
    return {
      sectionSubTitle: "",
      backgroundUrl: "",
      titleImgUrl: "",
      companyIntroduction: ""
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.getNavById();
    this.getCompanyInfo();
  },
  methods: {
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 2)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.titleImgUrl = resp.data.data.titleImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.titleImgUrl = resp.data.data.titleImg;
            this.backgroundUrl = resp.data.data.bannerImg;
          }
        })
        .catch();
    },
    getCompanyInfo() {
      this.axios
        .get("/companyInformation/getCompanyInfo/")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.companyIntroduction = resp.data.data.companyIntroduction;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.company-info {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    min-height: 500px;
  }
}
</style>
